module.exports = __webpack_public_path__ + "images/category_lp/trading_card/assessment_achievements/6@2x_f38d6f25252247f0c2c6aa9ddbb6967c.png";